(function($, window, document) { // jQuery wrapper

    /**
     * Ajax Functions
     */
    window.sliders = {

        /**
         * Setup the functions
         */
        setup: function(){
            this.genericSlider();
        },

    	/**
    	 * Init a slick slider.
    	 */
        initSlider: function ($el, $args){

        	$el.slick($args);
        },

        /**
         * A generic slider function whose options can be instantiated by inline
         * data attributes.
         */
        genericSlider: function() {

            $el = $('.js--generic-slider');

            $el.each(function() {

                $arrows         = $(this).data('slick-arrows');
                $dots           = $(this).data('slick-dots');
                $autoplay       = $(this).data('slick-autoplay');
                $autoplay_speed = $(this).data('slick-autoplayspeed');
                $fade           = $(this).data('slick-fade');
                $infinite       = $(this).data('slick-infinite');
                $pauseOnHover   = $(this).data('slick-pause');
                $adaptiveHeight = $(this).data('slick-adaptive');
                
                $args = {       
                    arrows:        $arrows       == true ? true : false,
                    dots:          $dots         == true ? true : false,
                    infinite:      $infinite     == true ? true : false,
                    autoplay:      $autoplay     == true ? true : false,
                    pauseOnHover:  $pauseOnHover == true ? true : false,
                    fade:          $fade         == true ? true : false,
                    autoplaySpeed: $autoplay_speed,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: $adaptiveHeight == false ? false : true,
                    speed:1000,
                    prevArrow: '<div class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="rk-icon-left-chevron"></i></div>',
                    nextArrow: '<div class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="rk-icon-right-chevron"></i></div>',
                    customPaging : function(slider, i) {
                        return '<div class="slick-button"></div>';
                    },
                    appendArrows: $('.g--custom-slider-controls'),
                    appendDots: $('.g--custom-slider-controls'),
                };
                
                window.sliders.initSlider( $el, $args );

            });
        },
    };

}(window.jQuery, window, document));